import { Box, Stack, Typography } from '@mui/material';
import { Severity } from '../../../../common/enums/Severity';
import { SeverityBadge } from '../../../../common/instances/components/SeverityBadge';

type Props = {
  number: number;
  title: string;
  subtitle?: string | null;
};

export const RuleSummary = ({ number, title, subtitle }: Props) => {
  return (
    <Stack className="profile-rule-summary" tabIndex={0} role="presentation" data-role="tabbable" direction="row" gap={2} alignItems="center">
      <Box sx={{ width: '3rem', minWidth: '3rem' }}>
        <SeverityBadge severity={Severity.MED}>{number}</SeverityBadge>
      </Box>
      <Stack>
        <Typography fontWeight={500}>{title}</Typography>
        {subtitle && <Typography variant="body2">{subtitle}</Typography>}
      </Stack>
    </Stack>
  );
};
